export enum LoanType {
  /// None
  None = 0,

  /// Vehicle Loan
  Vehicle = 1,

  /// Consumer Loan
  Consumer = 2,

  /// Other Collateral Loan (motorcycles, boats, trailers, etc)
  OtherCollateral = 3,

  /// Roadside Coverage
  RoadSideCoverage = 4,

  // Not a LoanType but included here to UI feasibility
  VehicleNotFound = -9999
}
